"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newLandingDelete = newLandingDelete;
exports.newLandingDetail = newLandingDetail;
exports.newLandingEdit = newLandingEdit;
exports.newLandingPage = newLandingPage;
exports.newLandingSave = newLandingSave;
exports.toggleNewLandingStatus = toggleNewLandingStatus;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGaNewLanding';

// 上新落地页保存
function newLandingSave(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}

// 上新落地页编辑
function newLandingEdit(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 上新落地页分页
function newLandingPage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 上新落地页详情
function newLandingDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 上新落地页删除
function newLandingDelete(id) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 切换上新落地页状态
function toggleNewLandingStatus(newLandingId, status) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleStatus',
    method: 'post',
    data: {
      newLandingId: newLandingId,
      status: status
    }
  });
}